import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";

export const useValidFilters = () => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter(
      (filter) => filter.name === TableNames.REVIEW_PENDING_ORDERS_FROM_ALGOLIA,
    );
  }, [filters]);

  return validFilters;
};
